var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgPackageGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1273_181",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1273_181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 7.90375V18.6923C5 18.7821 5.02883 18.8558 5.0865 18.9135C5.14417 18.9712 5.21792 19 5.30775 19H18.6923C18.7821 19 18.8558 18.9712 18.9135 18.9135C18.9712 18.8558 19 18.7821 19 18.6923V7.90375H15.5V15.298L12 13.548L8.5 15.298V7.90375H5ZM5.30775 20.5C4.80908 20.5 4.38308 20.3234 4.02975 19.9703C3.67658 19.6169 3.5 19.1909 3.5 18.6923V7.00575C3.5 6.79175 3.53433 6.58758 3.603 6.39325C3.6715 6.19908 3.77433 6.01992 3.9115 5.85575L5.3155 4.15775C5.4795 3.94358 5.68458 3.78042 5.93075 3.66825C6.17692 3.55608 6.43717 3.5 6.7115 3.5H17.2693C17.5436 3.5 17.8054 3.55608 18.0548 3.66825C18.3041 3.78042 18.5108 3.94358 18.675 4.15775L20.0885 5.875C20.2257 6.03917 20.3285 6.21992 20.397 6.41725C20.4657 6.61475 20.5 6.82058 20.5 7.03475V18.6923C20.5 19.1909 20.3234 19.6169 19.9703 19.9703C19.6169 20.3234 19.1909 20.5 18.6923 20.5H5.30775ZM5.3905 6.404H18.6L17.5095 5.10575C17.4775 5.07375 17.4407 5.04808 17.399 5.02875C17.3573 5.00958 17.3141 5 17.2693 5H6.72125C6.67642 5 6.63308 5.00958 6.59125 5.02875C6.54958 5.04808 6.51275 5.07375 6.48075 5.10575L5.3905 6.404ZM10 7.90375V12.8558L12 11.8558L14 12.8558V7.90375H10Z",
    fill: "#A0A0A0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageGray);
export default __webpack_public_path__ + "static/media/package-gray.70986e20f167980dd7658fb88c40e50f.svg";
export { ForwardRef as ReactComponent };